module.exports = __webpack_public_path__ + "static/media/CONFETTIS-FLOU.253ac4ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Element/img/CONFETTIS-FLOU.png
// module id = 246
// module chunks = 0